import { InvoiceAccountNoteViewType } from 'api-client'

import { TranslationKey } from '~shared-components/translations/default'

export const getInvoiceLabelByType = (
  type: InvoiceAccountNoteViewType | undefined,
): TranslationKey => {
  switch (type) {
    case InvoiceAccountNoteViewType.Invoice:
      return 'label.invoice'
    case InvoiceAccountNoteViewType.Credit:
      return 'label.creditnote'
    case InvoiceAccountNoteViewType.Debit:
    default:
      return 'label.debitnote'
  }
}
